import { Entities, Projection, TOMCAT_URL } from 'src/common';
import { apiRequest } from 'src/actions/api/api';

export function deleteGeoFenceArea(geoFenceAreaId, reducerIndex = 0, projection = Projection.FULL) {
    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/delete/${geoFenceAreaId}`,
                secondaryActionTypes: [
                    `REQUEST_${Entities.GEOFENCE_AREA.action}`,
                    `SUCCESS_DELETE_${Entities.GEOFENCE_AREA.action}`,
                    `FAILURE_${Entities.GEOFENCE_AREA.action}`,
                ],
                method: 'DELETE',
                reducerIndex: reducerIndex,
                schema: Entities.GEOFENCE_AREA.schema,
            }),
        );
    };
}
